<template>
    <ModalComponent
        name="crear-patrocinador"
        title="Añadir nuevo patrocinador"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormInput label="Nombre" name="nombre" rules="required" rows="3" v-model="patrocinador.nombre" />
                </div>
                <div class="col-12">
                    <FormInput label="Url" name="url" rules="required" rows="3" v-model="patrocinador.url" />
                </div>
                <div class="col-12 mb-3">
                    <label>Imagen <small>(MEDIDAS: 400X200 - FORMATO: PNG - COLOR: BLANCO - PESO MÁXIMO: Menos de 500 KB )</small></label>
                    <br/>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="200"
                        :width="400"
                        @success="imagenSubida"
                        @removed="imagenBorrada"
                    />
                </div>
                <div class="col-12 mb-3">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="show_in_ticket" v-model="patrocinador.show_in_ticket"/>
                        <label for="show_in_ticket" class="custom-control-label">
                            Mostrar en la entrada
                        </label>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <Button type="submit" name="button" :disabled="patrocinador.imagen === null">GUARDAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: [],
        data() {
            return {
                patrocinador: {
                    nombre: null,
                    url: null,
                    imagen: null,
                },
                loading: false,
                url: this.config.API_BASE + '/upload/image?api_key=' + localStorage.getItem('token') + '&permisos=public'
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'crear-patrocinador', creado);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crear();
                }
            },
            crear() {
                this.loading = true;
                this.patrocinador.filters = {};
                this.patrocinador.lista_id = this.$store.getters.getListaId;
                this.$store.dispatch(this.config.getVuexAlias('back.patrocinadores.crear'), this.patrocinador).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
            imagenBorrada() {
                this.patrocinador.imagen = null;
            },
            imagenSubida(file, response) {
                this.patrocinador.imagen = response;
            }
        },
        components: {
            ModalComponent, Dropzone
        }
    }
</script>
